<div class="main-delete">
  <div class="text-part">
    <span class="text-part-title">{{ 'menu_management.delete_dialog.title' | translate }}</span>
    <span class="text-part-info">{{ 'menu_management.delete_dialog.description' | translate }}</span>
  </div>
  <div class="action-part">
    <button class="option-cancel option-shared" (click)="cancel()">{{ 'Cancel' | translate }}</button>
    <button class="option-delete option-shared" (click)="confirmDelete()">{{ 'delete' | translate }}</button>
  </div>
</div>
